import React, {Component} from 'react'
import {Scene, Entity} from 'aframe-react'

import Camera from './components/camera'

import PopupDisplay from './containers/popup-display'
import Boxes from './containers/boxes'

import MainSphere from './containers/main-sphere'
import InnerSphere from './components/inner-sphere'

import keyboard from './actions/keyboard'

import ToggleSlider from './containers/toggle-slider'

import Tutorial from './containers/tutorial'

import HUD from './containers/hud'

import ComponentEnity from "./components-aframe"

import statsGrabber from "./components-aframe/statsGrabber"

import animationEvent from "./components-aframe/animationEvents"

const sceneStyles = {
    position: "absolute",

    height: "100%",
    width: "100%",
}

console.log(navigator.userAgent)

class App extends Component {
    render() {
        return (
            <div>
                <div style={sceneStyles}>
                    <Scene /*antialias*/ light={{ defaultLightsEnabled: false }} /*stats*/ renderer={{sortObjects: true,}}>
                        <Camera/>


                        <Boxes/>

                        <InnerSphere />    
                        
                        <MainSphere /> 

                        <Entity position={{
                            x: 0,
                            y: 1.6,
                            z: 0,
                        }}>
                             <PopupDisplay/> 
                        </Entity>

                        <ToggleSlider/>   

                        {/* <Tutorial />    */}


                    </Scene>
                </div>

                <HUD />

            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js